import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import * as _moment from 'moment';
import { CaptchaService } from 'src/app/services/captcha.service';
import { LibroReclamacionVirtualService } from 'src/app/services/libroreclamacionvirtual.service';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export class CaptchaResponse {
  dntCaptchaImgUrl: string = ''; // Contiene la imagen en Base64
  dntCaptchaId: string;
  dntCaptchaTextValue: string;
  dntCaptchaTokenValue: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-libro-de-reclamaciones',
  templateUrl: './libro-de-reclamaciones.component.html',
  styleUrls: ['./libro-de-reclamaciones.component.css'],
   providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
  
})
export class LibroDeReclamacionesComponent implements OnInit {



  form:FormGroup;

  captchaData: CaptchaResponse;

  constructor(private _adapter: DateAdapter<any>,
    private libroReclamacionVirtualService: LibroReclamacionVirtualService,
    private captchaService: CaptchaService,private http:HttpClient  ) { }

  ngOnInit() {
    this.captchaData = new CaptchaResponse(); 
    this.form = new FormGroup({
      FechaReclamo: new FormControl('',Validators.required),   
      Nombres: new FormControl('',Validators.required), 
      Direccion: new FormControl('',Validators.required), 
      TipoDocumento: new FormControl('1',Validators.required), 
      NumeroDocumento: new FormControl('',Validators.required), 
      Telefono: new FormControl('',Validators.nullValidator),  
      Email: new FormControl('',[Validators.required, Validators.email]),  
      EsMenor: new FormControl('0',Validators.required),
      TipoSolicitud: new FormControl('',Validators.required), 
      DetalleSolicitud: new FormControl('',Validators.required), 
      Pedido: new FormControl('',Validators.required),  
      TipoBien: new FormControl('',Validators.required),
      MontoReclamo: new FormControl('',Validators.nullValidator), 
      DescripcionBien:  new FormControl('',Validators.nullValidator),  
      DNTUserInput: new FormControl('',Validators.required),
      Declaro: new FormControl(false,Validators.requiredTrue)
    });

    this.cargarCaptcha();

  }

  
  public hasError = (controlName: string, errorName: string) =>{
    return this.form.controls[controlName].hasError(errorName);
  } 

  inCodigoRespuesta:string = "";
  disabledEnviar:boolean = false; 
  mensajeError:string = "";
  onEnviar(){
     
    if(this.form.invalid){  
      this.form.markAllAsTouched();
      return;
    }

    /*
      const formData = new HttpParams()
      .set("Id","0" )
      .set("FechaReclamo", this.form.get('FechaReclamo').value)
      .set("Nombres", this.form.get('Nombres').value)
      .set("Direccion", this.form.get('Direccion').value)
      .set("IdTipoDocumento", this.form.get('TipoDocumento').value)
      .set("NumeroDocumento", this.form.get('NumeroDocumento').value)
      .set("Telefono", this.form.get('Telefono').value)
      .set("Email", this.form.get('Email').value)
      .set("EsMenor", this.form.get('EsMenor').value)
      .set("TipoSolicitud", this.form.get('TipoSolicitud').value)
      .set("DetalleSolicitud", this.form.get('DetalleSolicitud').value)
      .set("Pedido", this.form.get('Pedido').value)

       .set("TipoBien", this.form.get('TipoBien').value)
      .set("MontoReclamado", this.form.get('MontoReclamo').value)
      .set("DescripcionBienContratado", this.form.get('DescripcionBien').value)
      .set("DNTCaptchaInputText", this.form.get('DNTUserInput').value)
      .set("DNTCaptchaText", this.captchaData.dntCaptchaTextValue)
      .set("DNTCaptchaToken", this.captchaData.dntCaptchaTokenValue);*/
       

      
      let params = {  
        Id:"0",
        FechaReclamo: _moment(this.form.get('FechaReclamo').value).format('YYYY-MM-DD'),
        Nombres: this.form.get('Nombres').value,
        Direccion: this.form.get('Direccion').value, 
        IdTipoDocumento: this.form.get('TipoDocumento').value,
        NumeroDocumento: this.form.get('NumeroDocumento').value,
        Telefono: this.form.get('Telefono').value,  
        Email: this.form.get('Email').value,
        EsMenor: this.form.get('EsMenor').value,
        TipoSolicitud: this.form.get('TipoSolicitud').value,
        DetalleSolicitud: this.form.get('DetalleSolicitud').value,  
        Pedido: this.form.get('Pedido').value,
        TipoBien: this.form.get('TipoBien').value,
        MontoReclamado: this.form.get('MontoReclamo').value.toString(),
        DescripcionBienContratado: this.form.get('DescripcionBien').value,  
        DNTCaptchaInputText: this.form.get('DNTUserInput').value,
        DNTCaptchaText: this.captchaData.dntCaptchaTextValue,
        DNTCaptchaToken: this.captchaData.dntCaptchaTokenValue,
        Declaro: new Boolean(this.form.get('Declaro').value).toString()
      };

        const formData = new HttpParams({ fromObject: params });

      this.disabledEnviar = true; 

      this.libroReclamacionVirtualService.Insert(formData.toString()).subscribe(r => {
        this.inCodigoRespuesta = r.inCodigoRespuesta; 
        this.disabledEnviar = false; 
        
        if(r.inCodigoRespuesta == 200){
           this.resetForm();  
        }else{
          this.mensajeError = r.vcMensaje; 
          this.cargarCaptcha();
        }
      },error => {
        console.log(error);
      });
      


    
  }

  resetForm(){
    this.form.get('FechaReclamo').setValue(''); 
    this.form.get('Nombres').setValue('');
    this.form.get('Direccion').setValue('');  
    this.form.get('TipoDocumento').setValue('1');
    this.form.get('NumeroDocumento').setValue('');
    this.form.get('Telefono').setValue('');  
    this.form.get('Email').setValue('');
    this.form.get('EsMenor').setValue('0');
    this.form.get('TipoSolicitud').setValue('');
    this.form.get('DetalleSolicitud').setValue('');  
    this.form.get('Pedido').setValue('');
    this.form.get('TipoBien').setValue('');
    this.form.get('MontoReclamo').setValue('');
    this.form.get('DescripcionBien').setValue('');    
    this.form.get('DNTUserInput').setValue(''); 
  }

  cargarCaptcha() {
    this.captchaService.GetCaptcha().subscribe(res => {
      this.captchaData = res;
    });
  }




}
